<template>
    <div>
        <div class="sa-dialog sa-view-det-modal" @click.self="$emit('close-pop')">
            <div class="sa-dialog-body sa-fixed-right sa-fixed-bottom">
                <i class="icon-close sa-close sa-btn sa-close-line" @click="$emit('close-pop')"></i>
                <div class="sa-dialog-mob-cnt" v-if="medicalItems">
                    <p>{{ medicalItems.title }}</p>
                    <ul class="sa-medical-itm">
                        <li v-for="(item, index) in medicalItems.prescr_items" :key="index" :style="listItem(item)" @click="onSelectItem(item)">
                            <span>
                                <img :src="item.iconName" class="sa-mr5" alt="prescription image" width="20">
                                 {{ item.name }}</span>
                            <i :class="item.arrowIcn"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <AddProductMedicine :listData="listData" :prescribedItem="prescribedItem" :drugList="drugList"  :Item="Item"  v-if="isAddProductPopup" @close-pop="closePope()"/>
        </div>
    </div>
</template>
<script>
import AddProductMedicine from './AddProductMedicine.vue';


export default {
    components:{AddProductMedicine},
    props: ['medicalItems','drugList', 'editItemFlag', 'Items', 'prescribedItem','listData'],
    data() {
        return {
            isAddProductPopup:false,
            Item: null,
            // medicalItems: {
            //     title: 'Select item type',
            //     itemList: [
            //         {
            //             name: 'Add Medicine',
            //             iconName: 'icon-capsule',
            //             color: '#00BDC2',
            //             bgColor: '#F4FFFF',
            //             arrowIcn: 'icon-right-arrow'
            //         },
            //         {
            //             name: 'Add Milk',
            //             iconName: 'icon-capsule',
            //             color: '#F27D68',
            //             bgColor: '#FFEFED',
            //             arrowIcn: 'icon-right-arrow'
            //         },
            //         {
            //             name: 'Add Medical Device',
            //             iconName: 'icon-capsule',
            //             color: '#005BF1',
            //             bgColor: '#F5F9FF',
            //             arrowIcn: 'icon-right-arrow'
            //         },
            //         {
            //             name: 'Add Medical Supplies',
            //             iconName: 'icon-capsule',
            //             color: '#D79B00',
            //             bgColor: '#FFFAED',
            //             arrowIcn: 'icon-right-arrow'
            //         }
            //     ]
            // }
        }
    },
    mounted(){
        if(this.editItemFlag){
            this.onSelectItem(this.Items)
        }else{
            this.prescribedItem = null
        }
    },
    methods: {
        onSelectItem(item){
            if(item.name == 'Add Medicine' ){
                this.addMedicine()
            }else{
                this.Item = item
                this.isAddProductPopup = !this.isAddProductPopup
            }
            
        },
        closePope(){
            this.$parent.isMedicalItemList = false
            this.$parent.editItemFlag = false
            this.isAddProductPopup = !this.isAddProductPopup
            this.Item = null
            this.$emit('close-pop')
        },
        listItem(item) {
            return {
                color: item.color,
                border: `1px solid ${item.color}`,
                backgroundColor: item.bgColor
            }
        },
        addMedicine () {
      // webview back button
      if (typeof window!=undefined && window.ReactNativeWebView) {
        let data = {
          action: 'back',
          page: 'add medicine'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      this.$parent.$parent.editflag = false
      this.$parent.$parent.viewMedFlag = false
      this.$parent.$parent.drgid = null
      this.$parent.$parent.checkbox = false
      this.$parent.$parent.drugObj ={
                  apnt_id: null,
                  scientific_name: null,
                  pid: null,
                  drug_nm: null,
                  dose: null,
                  route: null,
                  dose_unit: null,
                  freq_nm: null,
                  dur: null,
                  dur_unit: null,
                  prn: "NO",
                  pharm:null,
                  indications: null,
                  icd10_code: {
                    en: null,
                    icd10_code: null
                  },
                  inst: null,
                }
    },
    },
}
</script>
<style>
.sa-medical-itm {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.sa-medical-itm li {
    display: flex;
    justify-content: space-between;
    padding: 16px 20px;
    border-radius: 10px;
    align-items: center;
}
</style>